export const ALL_REASON_ID = 'all'
export const DEFAULT_PAGE_SIZE = 25

export enum CancellationUsersTab {
  Users = 'users',
  Testimonials = 'testimonials',
}

export const CANCELLATION_REASON_COLORS = ['#6C63FF', '#00A8A8', '#F5A623', '#E95F8A', '#4D7CFE', '#7B7F86']
